import {
	VBtn,
	VCard,
	VCardText,
	VCardTitle,
	VIcon,
	VMenu
} from "vuetify/lib";
import KFullscreenDialog from "../General/KFullscreenDialog";

export default KFullscreenDialog.extend( {
	name: "KBaseMapDialog",

	props: {
		scrollable: {
			...KFullscreenDialog.options.props.scrollable,
			default: true
		}
	},

	render() {
		return <KFullscreenDialog
			attrs={this.$props}
			on={this.$listeners}
			scopedSlots={this.$scopedSlots}
		>
			{this.genActivator()}

			{Boolean( this.$slots.options ) && <VMenu
				bottom
				left
				minWidth="220px"
				offsetY
				slot="toolbar"
				scopedSlots={{
					activator: ( { on } ) =>
						<VBtn
							icon
							on={on}
							text
						>
							<VIcon>more_vert</VIcon>
						</VBtn>
				}}
			>
				<VCard>
					<VCardTitle>Map Options</VCardTitle>

					<VCardText>
						{this.$slots.options}
					</VCardText>
				</VCard>
			</VMenu>}
		</KFullscreenDialog>;
	}
} );
